import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "authentication-wrapper authentication-2 px-4" }
const _hoisted_2 = { class: "authentication-inner py-5" }
const _hoisted_3 = { class: "d-flex justify-content-center mb-3" }
const _hoisted_4 = ["src", "alt", "title"]
const _hoisted_5 = { class: "p-4" }
const _hoisted_6 = { class: "form-group mb-4" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "form-group mb-3" }
const _hoisted_9 = { class: "form-label d-flex justify-content-between align-items-end" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "d-flex justify-content-end align-items-center m-0" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "mt-3 text-center"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 1,
  class: "mt-3 text-center"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  key: 2,
  class: "mt-3 text-center"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notification = _resolveComponent("notification")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.imageURL,
            alt: _ctx.partner +' Logo',
            title: _ctx.partner +' Logo',
            height: "60",
            class: "cursor-pointer partner-logo",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.frontEndPartner && _ctx.frontEndPartner(...args)))
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("form", {
          class: "card",
          name: "loginform",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-center text-muted mb-4" }, "Login", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "mt-0 mb-4" }, null, -1)),
            (_ctx.error)
              ? (_openBlock(), _createBlock(_component_notification, {
                  key: 0,
                  notification: _ctx.errorMessage,
                  index: 0,
                  fix_alert: false
                }, null, 8, ["notification"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { class: "form-label" }, "Email", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "email",
                name: "email",
                type: "email",
                disabled: _ctx.authenticating,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                autocomplete: "email",
                required: "",
                class: "form-control mt-1"
              }, null, 8, _hoisted_7), [
                [_vModelText, _ctx.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, [
                _cache[6] || (_cache[6] = _createElementVNode("div", null, "Password", -1)),
                _createVNode(_component_router_link, {
                  to: "/forgot-password",
                  disabled: _ctx.authenticating,
                  class: "d-block"
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode(" Forgot your password? ")
                  ])),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "password",
                name: "password",
                type: "password",
                disabled: _ctx.authenticating,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                autocomplete: "current-password",
                required: "",
                class: "form-control mt-1"
              }, null, 8, _hoisted_10), [
                [_vModelText, _ctx.password]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "submit",
                name: "loginformsubmit",
                disabled: _ctx.authenticating,
                class: "btn btn-primary"
              }, "Sign In", 8, _hoisted_12)
            ])
          ])
        ], 32),
        (_ctx.partner !== 'sp' && _ctx.partner !== 'simclusive')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _cache[9] || (_cache[9] = _createTextVNode(" Don't have an account?")),
              _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("a", { href: _ctx.basicRegistration }, "Register today!", 8, _hoisted_14)
            ]))
          : (_ctx.partner == 'sp')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("p", null, [
                  _createElementVNode("a", { href: _ctx.authorRegistration }, "Want to Become a Scenario Author?", 8, _hoisted_16)
                ]),
                _createElementVNode("a", { href: _ctx.spRegistration }, "Want to Become a SP?", 8, _hoisted_17)
              ]))
            : (_ctx.partner == 'simclusive')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("p", null, [
                    _createElementVNode("a", { href: _ctx.simAuthorRegistration }, "Want to Become a Scenario Author?", 8, _hoisted_19)
                  ]),
                  _createElementVNode("a", { href: _ctx.requestQuote }, "Request a Quote?", 8, _hoisted_20)
                ]))
              : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_loading, {
      active: _ctx.authenticating,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}